module.exports = __webpack_public_path__ + "static/img/21.6571d1c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/5/zh/21.png
// module id = LBu8
// module chunks = 0